import * as React from 'react';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Card} from '@material-ui/core';
import {faLightbulb, faTemperatureQuarter, faPowerOff, faFan, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { RoomControlButton, RoomControlAdjustableButton } from 'components';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'top',
      background: 'linear-gradient(to bottom, #ffffff, #f0f0f0)',
    },
    form: {
      width: '100%',
      maxWidth: 400,
      padding: theme.spacing(1),
      background: '#fff',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    subform_Row: {
        width: '100%',
        maxWidth: 200,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    subform_Column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: theme.spacing(3),
    }
  }),
);

interface IProps {
  onCompleted: (isCompleted: boolean) => void;
};

export const RoomControlCard: React.FC<IProps> = ({onCompleted}) => {
    const lightGreen = '#66bb6a'; 
    const bigButtonTextSize = '1.0rem';
    const smallButtonTextSize = '0.7rem';
   
    const acSpeed: string[] = ["LOW", "MEDIUM", "HIGH"];

    const temperatures: string[] = [];
    for (let temp = 16; temp <= 30; temp++) {
        temperatures.push(`${temp}°C`);
    }
    
    const theme = useTheme();
    const classes = useStyles();
    const [isDayClicked, setIsDayClicked] = React.useState(false);
    const [isNightClicked, setIsNightClicked] = React.useState(false);
    const [isOffLightClicked, setIsOffLightClicked] = React.useState(false);

    const [isBathRoom1Light1Clicked, setIsBathRoom1Light1Clicked] = React.useState(false);
    const [isBathRoom1Light2Clicked, setIsBathRoom1Light2Clicked] = React.useState(false);

    const [isBathRoom2Light1Clicked, setIsBathRoom2Light1Clicked] = React.useState(false);
    const [isBathRoom2Light2Clicked, setIsBathRoom2Light2Clicked] = React.useState(false);

    const [isBedRoom1Light1Clicked, setIsBedRoom1Light1Clicked] = React.useState(false);
    const [isBedRoom1Light2Clicked, setIsBedRoom1Light2Clicked] = React.useState(false);

    const [isBedRoom2Light1Clicked, setIsBedRoom2Light1Clicked] = React.useState(false);
    const [isBedRoom2Light2Clicked, setIsBedRoom2Light2Clicked] = React.useState(false);

    const [isLivingRoomLight1Clicked, setIsLivingRoomLight1Clicked] = React.useState(false);
    const [isLivingRoomLight2Clicked, setIsLivingRoomLight2Clicked] = React.useState(false);

    const [isKitchenLight1Clicked, setIsKitchenLight1Clicked] = React.useState(false);
    const [isKitchenLight2Clicked, setIsKitchenLight2Clicked] = React.useState(false);

    const [isOffTemperatureClicked, setIsOffTemperatureClicked] = React.useState(false);
 
    const handleDayClick = () => {
        setIsDayClicked((prev)=>!prev);    
    };
    const handleNightClick = () => {
        setIsNightClicked((prev)=>!prev);    
    };
    const handleOffLightClick = () => {
        setIsOffLightClicked((prev)=>!prev);   
    };

    const handleBathRoom1Light1Click = () => {
        setIsBathRoom1Light1Clicked((prev) => !prev);
    };
    const handleBathRoom1Light2Click = () => {
        setIsBathRoom1Light2Clicked((prev) => !prev);
    };
    const handleBathRoom2Light1Click = () => {
        setIsBathRoom2Light1Clicked((prev) => !prev);
    };
    const handleBathRoom2Light2Click = () => {
        setIsBathRoom2Light2Clicked((prev) => !prev);
    };

    const handleBedRoom1Light1Click = () => {
        setIsBedRoom1Light1Clicked((prev) => !prev);
    };
    const handleBedRoom1Light2Click = () => {
        setIsBedRoom1Light2Clicked((prev) => !prev);
    };
    const handleBedRoom2Light1Click = () => {
        setIsBedRoom2Light1Clicked((prev) => !prev);
    };
    const handleBedRoom2Light2Click = () => {
        setIsBedRoom2Light2Clicked((prev) => !prev);
    };

    const handleLivingRoomLight1Click = () => {
        setIsLivingRoomLight1Clicked((prev) => !prev);
    };
    const handleLivingRoomLight2Click = () => {
        setIsLivingRoomLight2Clicked((prev) => !prev);
    };

    const handleKitchenLight1Click = () => {
        setIsKitchenLight1Clicked((prev) => !prev);
    };
    const handleKitchenLight2Click = () => {
        setIsKitchenLight2Clicked((prev) => !prev);
    };
    
    const handleOffTemperatureClick = () => {
        setIsOffTemperatureClicked((prev) => !prev);
    };

    React.useEffect(()=>{
       onCompleted(false);
    },[]);

    React.useEffect(()=>{
        if(isOffLightClicked){
            setIsDayClicked(false);    
            setIsNightClicked(false);
            setIsBathRoom1Light1Clicked(false);
            setIsBathRoom1Light2Clicked(false);
            setIsBathRoom2Light1Clicked(false);
            setIsBathRoom2Light2Clicked(false);
            setIsBedRoom1Light1Clicked(false);
            setIsBedRoom1Light2Clicked(false);
            setIsBedRoom2Light1Clicked(false);
            setIsBedRoom2Light2Clicked(false);
            setIsLivingRoomLight1Clicked(false);
            setIsLivingRoomLight2Clicked(false);
            setIsKitchenLight1Clicked(false);
            setIsKitchenLight2Clicked(false);
            onCompleted(true);
        }
    },[isOffLightClicked]);

    React.useEffect(()=>{
        if(isDayClicked){
            setIsOffLightClicked(false);
            setIsNightClicked(false);
            setIsBathRoom1Light1Clicked(true);
            setIsBedRoom1Light1Clicked(true);
            setIsLivingRoomLight1Clicked(true);
            setIsKitchenLight1Clicked(true);
            setIsBedRoom2Light1Clicked(true);

            setIsBathRoom1Light2Clicked(false);
            setIsBedRoom1Light2Clicked(false);
            setIsLivingRoomLight2Clicked(false);
            setIsKitchenLight2Clicked(false);
            setIsBedRoom2Light2Clicked(false);
            onCompleted(true);
        }
        else{
            setIsBathRoom1Light1Clicked(false);
            setIsBedRoom1Light1Clicked(false);
            setIsLivingRoomLight1Clicked(false);
            setIsKitchenLight1Clicked(false);
            setIsBedRoom2Light1Clicked(false);
        }
    },[isDayClicked]);

    React.useEffect(()=>{
        if(isNightClicked){
            setIsOffLightClicked(false);
            setIsDayClicked(false);
            setIsBathRoom1Light1Clicked(false);
            setIsBedRoom1Light1Clicked(false);
            setIsLivingRoomLight1Clicked(false);
            setIsKitchenLight1Clicked(false);
            setIsBedRoom2Light1Clicked(false);

            setIsBathRoom1Light2Clicked(true);
            setIsBedRoom1Light2Clicked(true);
            setIsLivingRoomLight2Clicked(true);
            setIsKitchenLight2Clicked(true);
            setIsBedRoom2Light2Clicked(true);
            onCompleted(true);
        }
        else{
            setIsBathRoom1Light2Clicked(false);
            setIsBedRoom1Light2Clicked(false);
            setIsLivingRoomLight2Clicked(false);
            setIsKitchenLight2Clicked(false);
            setIsBedRoom2Light2Clicked(false);
        }
    },[isNightClicked]);

    React.useEffect(()=>{
        if(isOffTemperatureClicked){
            onCompleted(true);
        }
    },[isOffTemperatureClicked]);

    React.useEffect(()=>{
        if(!isOffLightClicked && !isDayClicked && !isNightClicked && !isOffTemperatureClicked){
            onCompleted(false);
        }
    },[isOffLightClicked, isDayClicked, isNightClicked, isOffTemperatureClicked]);
    return (
        <div className={classes.container}>
            <Card className={classes.card}>
                <Typography variant='h6'>Room Control - Light</Typography>
                <div className={classes.form}>
                    <RoomControlButton onClicked={handleDayClick} isClicked={isDayClicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="5x" iconText="DAY" buttonSize={200} textFontSize={bigButtonTextSize}/>
                    <RoomControlButton onClicked={handleNightClick} isClicked={isNightClicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="5x" iconText="NIGHT"  buttonSize={200} textFontSize={bigButtonTextSize} />
                </div>
                <div className={classes.form}>
                    <RoomControlButton onClicked={handleOffLightClick} isClicked={isOffLightClicked}  clickColor={theme.palette.secondary.light} noClickColor={theme.palette.primary.main} icon={faPowerOff} iconSize="5x" iconText="OFF" buttonSize={200} textFontSize={bigButtonTextSize}/>
                    <div className={classes.subform_Column}>
                        <div className={classes.subform_Row}>
                            <RoomControlButton onClicked={handleLivingRoomLight1Click} isClicked={isLivingRoomLight1Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="BALCONY LIGHT 1" buttonSize={100} textFontSize={smallButtonTextSize}/>
                            <RoomControlButton onClicked={handleLivingRoomLight2Click} isClicked={isLivingRoomLight2Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="BALCONY LIGHT 2" buttonSize={100} textFontSize={smallButtonTextSize}/>
                        </div>
                        <div className={classes.subform_Row}>
                            <RoomControlButton onClicked={handleKitchenLight1Click} isClicked={isKitchenLight1Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="CEILING FAN LIGHT 1" buttonSize={100} textFontSize={smallButtonTextSize}/>
                            <RoomControlButton onClicked={handleKitchenLight2Click} isClicked={isKitchenLight2Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="CEILING FAN LIGHT 2" buttonSize={100} textFontSize={smallButtonTextSize}/>
                        </div>
                    </div>                
                </div>
                <div className={classes.form}>
                    <div className={classes.subform_Column}>
                        <div className={classes.subform_Row}>
                            <RoomControlButton onClicked={handleBedRoom1Light1Click} isClicked={isBedRoom1Light1Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="BED ROOM CEILING LIGHT 1" buttonSize={100} textFontSize={smallButtonTextSize}/>
                            <RoomControlButton onClicked={handleBedRoom1Light2Click} isClicked={isBedRoom1Light2Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="BED ROOM CEILING LIGHT 2" buttonSize={100} textFontSize={smallButtonTextSize}/>
                        </div>
                        <div className={classes.subform_Row}>
                            <RoomControlButton onClicked={handleBathRoom1Light1Click} isClicked={isBathRoom1Light1Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="BATH ROOM LIGHT 1" buttonSize={100} textFontSize={smallButtonTextSize}/>
                            <RoomControlButton onClicked={handleBathRoom1Light2Click} isClicked={isBathRoom1Light2Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="BATH ROOM LIGHT 2" buttonSize={100} textFontSize={smallButtonTextSize}/>
                        </div>
                    </div>
                    <div className={classes.subform_Column}>
                        <div className={classes.subform_Row}>
                            <RoomControlButton onClicked={handleBedRoom2Light1Click} isClicked={isBedRoom2Light1Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="CLOSET LIGHT" buttonSize={100} textFontSize={smallButtonTextSize}/>
                            <RoomControlButton onClicked={handleBedRoom2Light2Click} isClicked={isBedRoom2Light2Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="DESK LAMP" buttonSize={100} textFontSize={smallButtonTextSize}/>
                            
                        </div>
                        <div className={classes.subform_Row}>
                            <RoomControlButton onClicked={handleBathRoom2Light1Click} isClicked={isBathRoom2Light1Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="BEDSIDE LAMP 1" buttonSize={100} textFontSize={smallButtonTextSize}/>
                            <RoomControlButton onClicked={handleBathRoom2Light2Click} isClicked={isBathRoom2Light2Clicked}  clickColor={lightGreen} noClickColor={theme.palette.primary.main} icon={faLightbulb} iconSize="2x" iconText="BEDSIDE LAMP 2" buttonSize={100} textFontSize={smallButtonTextSize}/>
                        </div>
                    </div>                
                </div>
            </Card> 
            <Card className={classes.card}>
                <Typography variant='h6'>Room Control - Temperature</Typography>
                    <RoomControlButton onClicked={handleOffTemperatureClick} isClicked={isOffTemperatureClicked}  clickColor={theme.palette.secondary.light} noClickColor={theme.palette.primary.main} icon={faPowerOff} iconSize="5x" iconText="ON/OFF AC" buttonSize={200} textFontSize={bigButtonTextSize}/>
                    <RoomControlAdjustableButton icon={faTemperatureQuarter} iconSize="5x" iconText="TEMPERATURE"  buttonSize={200} textFontSize={bigButtonTextSize} adjustLeftIcon={faAngleLeft} adjustRightIcon={faAngleRight} arrayItems={temperatures} defaultIndex={4}/>
                    <RoomControlAdjustableButton icon={faFan} iconSize="5x" iconText="AC SPEED" buttonSize={200} textFontSize={bigButtonTextSize} adjustLeftIcon={faAngleLeft} adjustRightIcon={faAngleRight} arrayItems={acSpeed} defaultIndex={1}/>                                       
            </Card>               
        </div>
    );
};